/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Mitch Wilson <mitchell.wilson@deliciousai.com>
 */

import { gql } from '@apollo/client'

export const DASHBOARD_INTERVAL_STAT_FRAGMENT = gql`
  fragment DashboardIntervalStat on DashboardIntervalStat {
    date
    totalRevenue
    insideSales
    emptyFacings
    compliance
    restockCompletion
    taskCompletion
  }
`
